<template>
    <div>
        <div>
            <breadcrumb v-bind:manager="manager" v-bind:group="group"></breadcrumb>
            <navbar v-if="!singleFileView" v-bind="group"></navbar>
        </div>
        <div>
            <div class="fm-content-body">
                <table-view v-if="viewType === 'table'" v-bind:manager="manager"></table-view>
                <grid-view v-else v-bind:manager="manager"></grid-view>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import DiskList from './DiskList.vue';
import Breadcrumb from './Breadcrumb.vue';
import TableView from './TableView.vue';
import GridView from './GridView.vue';
import Navbar from '../blocks/Navbar.vue';

export default {
  name: 'Manager',
  components: {
    DiskList,
    Breadcrumb,
    TableView,
    GridView,
    Navbar,
  },
  props: {
    group: null,
    manager: { type: String, required: true },
  },
  computed: {
    singleFileView() {
      return this.$store.state.fm[this.manager].targetFile;
    },
    /**
     * view type - grid or table
     * @returns {default.computed.viewType|(function())|string}
     */
    viewType() {
      return this.$store.state.fm[this.manager].targetFile ? null : this.$store.state.fm[this.manager].viewType;
    },
  },
  methods: {
    redirectToBaseUrl() {
      const baseUrl = window.location.origin + window.location.pathname;
      window.location = baseUrl;
    },
  },
};
</script>

<style lang="scss">
    .fm-content {
        height: 100%;
        padding-left: 1rem;

    .fm-content-body {
        overflow: auto;
    }
    }
</style>
